import React from 'react';
import { Icon } from 'antd';
import PropTypes from 'prop-types';

function RegistroStatus({ registryStatus, ctx }) {
  switch (registryStatus) {
    case 'C':
      return (
        <div className="info-box">
          <span className="info-box-icon bg-orange">
            <Icon type="lock" />
          </span>
          <div className="info-box-content">
            <span className="info-box-text">Stato Registro</span>
            <span className="info-box-number">Chiuso in attesa di approvazione</span>
          </div>
        </div>
      );
    case 'A':
      return (
        <div className="info-box">
          <span className="info-box-icon bg-green">
            <Icon type="like" />
          </span>
          <div className="info-box-content">
            <span className="info-box-text">Stato Registro</span>
            <span className="info-box-number">Approvato</span>
          </div>
        </div>
      );
    case 'Z':
      return (
        <div className="info-box">
          <span className="info-box-icon bg-green">
            <Icon type="audit" />
          </span>
          <div className="info-box-content">
            <span className="info-box-text">Stato Registro</span>
            <span className="info-box-number">Approvato e archiviato</span>
          </div>
        </div>
      );
    case 'N':
    default:
      return (
        <div className="info-box">
          <span className="info-box-icon bg-light-blue">
            <Icon type="edit" />
          </span>
          <div className="info-box-content">
            <span className="info-box-text">Stato Registro</span>
            <span className="info-box-number">In compilazione</span>
          </div>
        </div>
      );
  }
}

RegistroStatus.propTypes = {
  registryStatus: PropTypes.string.isRequired,
  ctx: PropTypes.string,
};

export { RegistroStatus };
